<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M30.83,3.52,28.48,1.17a4,4,0,0,0-5.65,0L18.58,5.41,17.17,4a2,2,0,0,0-2.83,0L6.21,12.13a.5.5,0,0,0,0,.71l.7.71a.51.51,0,0,0,.71,0l8.13-8.14,1.41,1.42L5.87,18.13A20.42,20.42,0,0,0,0,30.32v0A1.5,1.5,0,0,0,1.34,32H1.5a20.27,20.27,0,0,0,12.37-5.87l17-17a4,4,0,0,0,0-5.65ZM12.46,24.71A18.5,18.5,0,0,1,2.08,29.93,18.45,18.45,0,0,1,7.29,19.54L18.58,8.24h0l5.18,5.17Zm17-17L25.17,12,20,6.83l4.24-4.24a2,2,0,0,1,2.83,0h0l2.35,2.34a2,2,0,0,1,0,2.83Z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
